/**
 * Function checks if string contains only digits
 */
String.prototype.isNumber = function () {
  return /^\d+$/.test(this);
};

/**
 * Convert string to Kebab case
 */
String.prototype.kebabCase = function () {
  return this.replace(/\s+/g, '-').toLowerCase();
};

/**
 * Cover string to camel case
 * @returns {string}
 */
String.prototype.camelize = function () {
  return this.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, (m, chr) => chr.toUpperCase());
};

/**
 * Convert array of objects to object
 * Example [ { id: 1, value: 2 }, { id: 3, value: 4 } ] => { 1: 2, 3: 4 }
 * @returns {{}}
 */
Array.prototype.objectsToObject = function () {
  let result = {};
  for (let i = 0; i < this.length; i++) {
    const keys = Object.keys(this[i]);
    result[this[i][keys[0]]] = this[i][keys[1]];
  }
  return result;
};
